import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CorporativeIcon',
  props: {
  size: { default: 24 },
  fill: { default: 'none' }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})